import React from "react";
import { useState, useEffect } from "react";
import DialogBox from "../../components/DialogBox";
import { instance as axios } from "../../utils/axiosConfig";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import RadioSwitch from "../../components/RadioSwitch";
import ToggleSwitch from "../../components/ToggleSwitch";
import Swal from "sweetalert2";

function CreateInvoice() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    name: "",
    email: "",
    phone: "",
  });
  // const [customers, setCustomers] = useState([]);
  const [customerSearch, setCustomerSearch] = useState("");
  const [tempSearch, setTempSearch] = useState([]);
  const [selectedCust, setSelectedCust] = useState(null);
  const [openSearchBox, setOpenSearchBox] = useState(false);
  const [reOpenSearchBox, setReOpenSearchBox] = useState(false);
  const [selectedAppId, selectApp] = useState("");

  //
  const [send_by, setSendBy] = useState("SMS");
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [isScheduled, setIsScheduled] = useState(false);
  const [schedule_time, setScheduleTime] = useState("");
  const [isPreview, setIsPreview] = useState(false);

  const closeModal = () => {
    setIsDialogOpen(false);
  };

  const handleChange = (e) => {
    setNewCustomer({ ...newCustomer, [e.target.name]: e.target.value });
  };

  //
  const createInvoice = async () => {
    Swal.fire({
      title: "Disbaled",
      text: "Invoice creation has been disabled for now",
      icon: "error"
    });
    return
    if (!selectedCust) {
      return toast.warning("please select customer");
    }
    if (!selectedAppId) {
      return toast.warning("please select Payment App");
    }
    if (isScheduled && !schedule_time) {
      return toast.warning("please select Schedule dateTime");
    }
    if (!amount || Number(amount) < 1) {
      return toast.warning("Invalid amount");
    }
    if (!message) {
      return toast.warning("Enter message");
    }
    const data = {
      app_id: selectedAppId,
      customer_id: selectedCust?._id,
      amount: amount,
      message: message,
      is_scheduled: isScheduled,
      send_by: send_by,
      schedule_time: null,
    };

    try {
      const resp = await axios.post("/add-invoice", data);
      console.log(resp.data);
      const invoice_number = resp.data.savedInvoice.invoice_number;
      toast.success(`Invoice ${invoice_number} created successfully`);
    } catch (error) {
      console.log(error.response.data);
      toast.error(error.response.data);
    }
  };
  const addNewCustomer = async (e) => {
    e.preventDefault();

    //backend endpoint
    try {
      const { data } = await axios.post("/add-customer", newCustomer);
      if (data) {
        setSelectedCust(data.savedCustomer);
        setOpenSearchBox(true);
        setReOpenSearchBox(!reOpenSearchBox);
        setCustomerSearch("");
        setIsDialogOpen(false);
        setNewCustomer({
          name: "",
          email: "",
          phone: "",
        });
        toast.info(data.message);
      }

      //check the response and update the selected customer
    } catch (error) {
      //handle errors with a toast
      toast.error(error.message);
    }
  };

  const fetchData = async () => {
    const customerRes = await axios.get("/get-customers");
    const appsRes = await axios.get("/get-user-apps");
    return { customers: customerRes.data, apps: appsRes.data.apps };
  };

  const { data } = useQuery(["invoice"], fetchData);

  const getSelectedCustomer = (sltCustomer) => {
    setSelectedCust(sltCustomer);
    setOpenSearchBox(true);
    setReOpenSearchBox(!reOpenSearchBox);
    setCustomerSearch("");
  };

  const getReOpenSearchBox = () => {
    setReOpenSearchBox(!reOpenSearchBox);
    setTempSearch([]);
  };

  useEffect(() => {
    if (customerSearch) {
      const resultSearch = data?.customers?.filter((obj) => {
        obj.name = obj?.name?.toLowerCase();
        return obj?.name?.includes(customerSearch.toLowerCase());
      });
      setTempSearch(resultSearch);
    } else {
      setTempSearch([]);
    }
  }, [customerSearch, data?.customers]);

  return (
    <div>
      <div className="flex flex-row-reverse sm:flex-row items-center justify-between shadow-sm py-4">
        <XMarkIcon className="w-6 cursor-pointer" />
        <h1 className="font-semibold text-xl lg:text-3xl tracking-wide text-gray-700 ">
          New Invoice
        </h1>
        <div className="space-y-2 md:space-y-0 mx-3 md:mx-0 flex md:flex-row flex-col items-center space-x-3 absolute bottom-3 right-0 left-0 sm:relative">
          <button
            className={`block md:hidden ${
              !isPreview
                ? "w-full bg-yellow-100 text-yellow-900 hover:shadow-xl px-8 py-3 rounded-full"
                : "w-full bg-yellow-800 text-white px-8 py-3 hover:shadow-xl rounded-full"
            } `}
            onClick={isPreview ? createInvoice : () => setIsPreview(true)}
          >
            {isPreview ? "Send" : "Preview"}
          </button>
          {isPreview && (
            <button
              className="w-full block md:hidden bg-yellow-100 text-yellow-900 hover:shadow-xl px-8 py-3 rounded-full"
              onClick={() => setIsPreview(false)}
            >
              Back
            </button>
          )}
          <button
            className="w-full hidden md:block bg-yellow-800 text-white px-8 py-3 hover:shadow-xl rounded-full"
            onClick={createInvoice}
            
          >
            Send
          </button>
        </div>
      </div>
      <div className="flex mb-16 flex-col md:flex-row gap-4 md:gap-8 py-12">
        <div
          className={`${isPreview ? "hidden md:block" : ""} w-full md:w-1/2`}
        >
          <div className="flex items-center justify-between">
            <h1 className="text-xl">Customer</h1>
            <button
              type="button"
              className="py-1.5 px-2.5 mr-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:ring-4 focus:ring-gray-200"
              onClick={() => setIsDialogOpen(true)}
            >
              New Customer
            </button>
          </div>
          {/* <h1>{customers[0].name}</h1> */}
          {/* search input */}
          {openSearchBox ? (
            reOpenSearchBox ? (
              <div className="space-y-4">
                <div className="relative w-full">
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      id="simple-search"
                      value={customerSearch}
                      onChange={(e) => setCustomerSearch(e.target.value)}
                      className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full pl-10 p-2.5 "
                      placeholder="Find Customer by Name"
                      required
                    />
                    {tempSearch?.length > 0 && (
                      <div className="absolute bg-white w-full space-y-2 my-2 shadow-xl p-3 rounded-md">
                        {tempSearch?.map((cust) => {
                          return (
                            <div
                              onClick={() => getSelectedCustomer(cust)}
                              key={cust?._id}
                              className="flex items-center space-x-2 cursor-pointer"
                            >
                              <div className="w-9 h-9 rounded-full bg-gray-300"></div>
                              <p className="text-lg">{cust?.name}</p>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-full shadow bg-white p-2 rounded-lg flex items-center space-x-2">
                  <div className="w-9 h-9 rounded-full bg-gray-300"></div>
                  <div className="flex w-full items-center justify-between">
                    <p className="text-lg">{selectedCust?.name}</p>
                    <PencilIcon
                      onClick={() => getReOpenSearchBox()}
                      className="w-6 cursor-pointer"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full shadow bg-white p-2 rounded-lg flex items-center space-x-2">
                <div className="w-9 h-9 rounded-full bg-gray-300"></div>
                <div className="flex w-full items-center justify-between">
                  <div className="flex flex-col gap-1 mx-4">
                    <p className="text-lg">{selectedCust?.name}</p>
                    <p className="text-lg">{selectedCust?.phone}</p>
                  </div>
                  <PencilIcon
                    onClick={() => getReOpenSearchBox()}
                    className="w-6 cursor-pointer"
                  />
                </div>
              </div>
            )
          ) : (
            <div className="flex items-center my-4">
              <label htmlFor="simple-search" className="sr-only">
                Search
              </label>
              <div className="relative w-full">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5 text-gray-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    id="simple-search"
                    value={customerSearch}
                    onChange={(e) => setCustomerSearch(e.target.value)}
                    className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full pl-10 p-2.5 "
                    placeholder="Find Customer by Name"
                    required
                  />
                  {tempSearch?.length > 0 && (
                    <div className="absolute bg-white w-full space-y-2 my-2 shadow-xl p-3 rounded-md">
                      {tempSearch?.map((cust) => {
                        return (
                          <div
                            onClick={() => getSelectedCustomer(cust)}
                            key={cust?._id}
                            className="flex items-center space-x-2 cursor-pointer"
                          >
                            <div className="w-9 h-9 rounded-full bg-gray-300"></div>
                            <p className="text-lg">{cust?.name}</p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* end of search box  */}
          <div className="flex items-center justify-between my-4">
            <h1 className="text-xl">Payment App</h1>
            {/* <button
              type="button"
              className="py-1.5 px-2.5 mr-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 "
              onClick={() => setIsDialogOpen(true)}
            >
              New App
            </button> */}
          </div>
          <div className="mb-6">
            <select
              id="apps"
              name="app_id"
              onChange={(e) => selectApp(e.target.value)}
              value={selectedAppId}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
            >
              <option value="">Select App</option>
              {data?.apps.length >= 1 &&
                data?.apps.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.name} - {item.type}
                  </option>
                ))}
            </select>
          </div>
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Amount
            </label>
            <input
              type="number"
              name="amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
              placeholder="Eg 10 , 200 "
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="description"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Message
            </label>
            <textarea
              type="text"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
              placeholder="briefly describe the purpose of this link"
              required
            />
          </div>
        </div>
        <div
          className={`${isPreview ? "" : "hidden md:block"} w-full md:w-1/2`}
        >
          <h1 className="text-center  text-xl tracking-wide ">Preview</h1>
          <div className="mt-8">
            <h1>SEND BY:</h1>
            <RadioSwitch
              state={send_by}
              setter={(e) => setSendBy(e.target.value)}
            />
          </div>
          <div className="flex justify-between items-center mr-0 md:mr-12">
            <div className="flex flex-col">
              <h1>SCHEDULE INVOICE</h1>
              <h1>This will send the invoice on the selected date and time</h1>
            </div>
            <ToggleSwitch state={isScheduled} setter={setIsScheduled} />
          </div>
          {isScheduled && <div>select date and time components come here</div>}
        </div>
      </div>

      {/* Modal  */}
      <DialogBox
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        title="Create New Customer"
        onClose={closeModal}
      >
        <form onSubmit={addNewCustomer}>
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={newCustomer.name}
              onChange={handleChange}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
              placeholder="app name"
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Email
            </label>
            <input
              type="email"
              id="name"
              name="email"
              value={newCustomer.email}
              onChange={handleChange}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
              placeholder="app name"
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Phone Number
            </label>
            <input
              type="phone"
              id="name"
              name="phone"
              value={newCustomer.phone}
              onChange={handleChange}
              className="bg-yellow-100 border border-yellow-400 text-yellow-900 text-sm rounded-lg focus:ring-yellow-400 focus:ring-2 focus:outline-none block w-full p-2.5"
              placeholder="app name"
              required
            />
          </div>
          <button
            type="submit"
            className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
          >
            Create Customer
          </button>
        </form>
      </DialogBox>
    </div>
  );
}

export default CreateInvoice;
